
export const API_BASE = "https://twitch1.fairytalefables.com/api/v1";
export const API_BASE_BASE = "https://twitch1.fairytalefables.com";
